import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    // 设置上传文件参数
    setUploadParams ({ commit }, params) { // 设置请求参数
      const formData = new FormData();
      // let filename = `${params.data.osskey}.${params.file.name.split('.')[1]}`
      // 文件名字，可设置路径
      formData.append('key', `${params.dir}/${params.ossFileName}`)
      // policy规定了请求的表单域的合法性
      formData.append('policy', params.policy)
      // Bucket 拥有者的Access Key Id
      formData.append('OSSAccessKeyId', params.accessid)
      // 让服务端返回200,不然，默认会返回204
      formData.append('success_action_status', '200')
      // 根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
      formData.append('callback', params.callback)
      formData.append('signature', params.signature)
      formData.append('name', params.file.name)
      // 需要上传的文件filer
      formData.append('file', params.file, params.file.name)
      return formData
    },
    // 上传文件
    uploadFile ({ commit }, {
      url,
      data
    }) { // 上传文件
      return new Promise((resolve, reject) => {
        axios.post(url, data)
          .then((res) => {
            return resolve(res)
          })
          .catch((err) => {
            return reject(err)
          })
      })
    }
  },
  modules: {}
})
